import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, CircularProgress, Tooltip, IconButton, Drawer, FormControlLabel, Checkbox, Chip, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LabelValueCard, RevisionHistory, PageLoader, DeletePopUp } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { capitalizeFirstLetter, checkApiStatus, getLocalStorageInfo, checkPermission, toastFlashMessage, downloadFile } from '../../../../utils_v2';
import { addEditReturnConApi, getReturnConApi } from '../apiServices';
import { fieldValidation } from '../../../../utils_v2/formValidation';
import { errorCodeReturnCondition, addReturnCondition } from '../../';
import { DropzoneArea } from 'material-ui-dropzone';
import { globalDeleteService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { assetId } from '../../../../constants';
import zIndex from '@material-ui/core/styles/zIndex';
import { avationPlcInstance, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
import { regexConstants } from '../../../../constants/regEx';
import InfoIcon from '@material-ui/icons/Info';
class ReturnCondCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      returnCond: {},
      error: {},
      attatchedDoc:[],
      previewDocs: '',
      deleteAttachmentModal: false, 
      deleteItem: null,
    }
    this.addEditReturnConApi = addEditReturnConApi.bind(this);
    this.getReturnConApi = getReturnConApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    if (['type','serviceable','tslsv_fh','tslsv_fc','tslsv_month','tnsv_fc','tnsv_fh',
      'tnsv_month','serial_number','event_type','months_since_last_sv','hours_since_last_sv', 'cycles_since_last_sv', 
      'released','reading','flight_hours','flight_cycles','block_hours', 'apu_hours','apu_cycle',].includes(keyParam)) {
      this.setState(prevState => ({
        returnCond: {
          ...prevState.returnCond,
          titan_extra_fields: {
            ...prevState.returnCond?.titan_extra_fields,
            [keyParam]: data,
          },
        },
      }));
    }else{
    this.setState(prevState => ({
      ...prevState,
      returnCond: {
        ...prevState.returnCond,
        [keyParam]: data
      }
    }))
  }
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  addRtnAttachment = (data) => {
    const { props, params } = this.props;
    const { attatchedDoc, returnCond } = this.state;
    let formdata = new FormData();

    attatchedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '9');
    formdata.append('object_id', data?.id)  
    this.setState({ pageLoader: true });
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response?.data?.statusCode === 200) {
          toastFlashMessage(response.data.message, 'success');
        } else {
          toastFlashMessage(response.data.message, 'error');
        }
        this.setState({ pageLoader: false });
        this.props.getResponseBack();
      });
  }
  addEditReturnFn = () => {
    const { returnCond } = this.state;
    let validationInputs = {
      asset_conditions_for_contract: errorCodeReturnCondition['asset_conditions_for_contract'][fieldValidation({ ...errorCodeReturnCondition['asset_conditions_for_contractObj'], fieldval: returnCond.asset_conditions_for_contract && returnCond.asset_conditions_for_contract.id ? returnCond.asset_conditions_for_contract.id.toString() : '' })],
      terms: errorCodeReturnCondition['terms'][fieldValidation({ ...errorCodeReturnCondition['termsObj'], fieldval: returnCond.terms })],
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      if (this.state.attatchedDoc?.length + returnCond?.pooling_language?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      this.setState({ formSubmitLoader: true });
      let payload = Object.assign({}, returnCond);
      payload = {
        ...payload,
        asset_conditions_for_contract_id: returnCond.asset_conditions_for_contract.id
      }
      this.addEditReturnConApi(this.props, payload)
        .then(response => {
          if (checkApiStatus(response)) {
            if (this.state.attatchedDoc?.length) {
                this.addRtnAttachment(response?.data?.data);
                this.setState({ modal: false, mode: '', returnCond: {}, error: {} });
            } else {
              this.setState({ modal: false, mode: '', returnCond: {}, error: {} });
            }
            this.props.getResponseBack();
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
    } else {
      this.setState({ error: validationInputs });
    }
  }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };
  
  deleteAttachment = (item) => {
    const { returnCond , deleteItem} = this.state;
      this.setState({ deleteAttachmentModal: false, pageLoader: true });
      globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false }); 
        if (response?.data?.statusCode === 200) {
          const updatedPoolingLanguage = returnCond.pooling_language.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({returnCond: { ...returnCond, pooling_language: updatedPoolingLanguage }});
          this.getReturnConApi(this.props, returnCond.id); 
          this.props.getResponseBack();
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })

  };
  render() {
    const { modal, formSubmitLoader, mode, returnCond, error, pageLoader, previewDocs, deleteAttachmentModal } = this.state;
    const { id, m, contractClauseList, contractInfo } = this.props;
    const updatedFileLimit = id ? 50 -this.state.attatchedDoc?.length - returnCond?.pooling_language?.length : 50
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getReturnConApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{cursor:'pointer'}}/></Tooltip></span>
          :
          contractInfo?.hdlineInfo?.archived_asset ?
          null:
          <Button onClick={() => this.setState({ modal: true, returnCond: addReturnCondition, mode: 'add' })} variant="contained" color="primary"><AddIcon style={{fontSize: '1.15rem'}} />Add Return Condition</Button>
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', returnCond: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container" >
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Return Condition`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctreturnconditionitems/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      { contractInfo?.hdlineInfo?.archived_asset == false && checkPermission('contracts','return_conditions', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span>}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{position:'sticky'}}>
                <Grid container spacing={2}>
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Clause' value={returnCond.asset_conditions_for_contract && returnCond.asset_conditions_for_contract.name ? returnCond.asset_conditions_for_contract.name : '--'} /> :
                    <Grid item xs={12} md={12}>
                      <Autocomplete
                        options={contractClauseList}
                        getOptionLabel={option => option.name}
                        value={returnCond.asset_conditions_for_contract ? returnCond.asset_conditions_for_contract : null}
                        id="asset_conditions_for_contract"
                        onChange={(e, value) => { this.onFieldChange(e, 'asset_conditions_for_contract', value); }}
                        renderInput={params => <TextField required onFocus={(e) => this.updateErrorField('asset_conditions_for_contract', '')} error={error.asset_conditions_for_contract ? true : false} helperText={error.asset_conditions_for_contract ? error.asset_conditions_for_contract : ''} {...params} label="Clause" placeholder="Select Clause" margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Terms" value={ returnCond.terms? ( <span dangerouslySetInnerHTML={{ __html: returnCond.terms.replace(/\n/g, '<br />')}}/>): '--'}/>:
                    <Grid item xs={12}>
                      <TextField
                        required
                        id="terms"
                        label="Terms"
                        fullWidth
                        margin="normal"
                       // inputProps={{ maxLength: 1000 }}
                        value={returnCond.terms}
                        error={error.terms ? true : false}
                        InputLabelProps={{ shrink: true }}
                        helperText={error.terms ? error.terms : ''}
                        onChange={(e) => this.onFieldChange(e, 'terms', e.target.value)}
                        onFocus={(e) => this.updateErrorField('terms', '')}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label='Exceptions' value={returnCond.exceptions_done ? returnCond.exceptions_done : '--'} /> :
                    <Grid item xs={12}>
                      <TextField
                        id="exceptions_done"
                        label="Exceptions"
                        fullWidth
                        margin="normal"
                        multiline
                        rows="4"
                        inputProps={{ maxLength: 255 }}
                        value={returnCond.exceptions_done}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'exceptions_done', e.target.value)}
                      />
                    </Grid>
                  }
                  {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance)?<>
                  {mode === 'view' ?
                  <LabelValueCard md={6} label='Type' value={returnCond?.titan_extra_fields?.type ? returnCond?.titan_extra_fields?.type : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="type"
                        label="Type"
                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.type}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'type', e.target.value)}
                      />
                    </Grid>
                    }</>:null}
                    {(avationPlcInstance||mtInstance||leshaBankInstance)?<>
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Serviceable' value={returnCond?.titan_extra_fields?.serviceable ? returnCond?.titan_extra_fields?.serviceable : '--'} /> :
                      <Grid item xs={6} md={6}>
                        {(() => {
                          let options = ['Yes', 'No'];
                          return (
                            <Autocomplete
                              options={options}
                              disableClearable={true}
                              getOptionLabel={option => option}
                              name="serviceable"
                              value={returnCond?.titan_extra_fields?.serviceable}
                              onChange={(e, value) => { this.onFieldChange(e, 'serviceable', value); }}
                              renderInput={params => <TextField style={{height:'49px' }} {...params} label="Serviceable " placeholder='Select Serviceable' margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                            />
                          )
                        })()}
                      </Grid>
                    }</>:null}
                    {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance)?<>
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Serial Number' value={returnCond?.titan_extra_fields?.serial_number ? returnCond?.titan_extra_fields?.serial_number : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="serial_number"
                          label="Serial Number"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.serial_number ? returnCond?.titan_extra_fields?.serial_number : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'serial_number', e.target.value)}
                        />
                      </Grid>
                    }  
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Event Type' value={returnCond?.titan_extra_fields?.event_type ? returnCond?.titan_extra_fields?.event_type : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="event_type"
                          label="Event Type"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.event_type ? returnCond?.titan_extra_fields?.event_type : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'event_type', e.target.value)}
                        />
                      </Grid>
                    }</>:null}
                  {(avationPlcInstance||mtInstance||titanInstance||leshaBankInstance)?<>
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TSLSV FH<Tooltip title="Time Since the Last Shop Visit FH" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tslsv_fh ? returnCond?.titan_extra_fields?.tslsv_fh : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tslsv_fh"
                        label={
                          <span style={{ display: 'flex', alignItems: 'center' }}>
                              TSLSV FH
                              <Tooltip title="Time Since the Last Shop Visit FH" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip>
                          </span>}
                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tslsv_fh?returnCond?.titan_extra_fields?.tslsv_fh:''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ?this.onFieldChange(e, 'tslsv_fh', e.target.value):e.preventDefault()}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TSLSV FC<Tooltip title="Time Since the Last Shop Visit FC" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tslsv_fc ? returnCond?.titan_extra_fields?.tslsv_fc : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tslsv_fc"
                        label={<span style={{ display: 'flex', alignItems: 'center' }}>TSLSV FC<Tooltip title="Time Since the Last Shop Visit FC" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>}
                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tslsv_fc?returnCond?.titan_extra_fields?.tslsv_fc:''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ?this.onFieldChange(e, 'tslsv_fc', e.target.value):e.preventDefault()}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TSLSV Month<Tooltip title="Time Since the Last Shop Visit Month" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tslsv_month ? returnCond?.titan_extra_fields?.tslsv_month : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tslsv_month"
                        label={<span style={{ display: 'flex', alignItems: 'center' }}>TSLSV Month<Tooltip title="Time Since the Last Shop Visit Month" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>}                        
                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tslsv_month}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'tslsv_month', e.target.value)}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV FH<Tooltip title="Time to the Next Shop Visit FH" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tnsv_fh ? returnCond?.titan_extra_fields?.tnsv_fh : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tnsv_fh"
                        label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV FH<Tooltip title="Time to the Next Shop Visit FH" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>}                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tnsv_fh?returnCond?.titan_extra_fields?.tnsv_fh:''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => regexConstants.numberWithDot.test(e.target.value)?this.onFieldChange(e, 'tnsv_fh', e.target.value):e.preventDefault()}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV FC<Tooltip title="Time to the Next Shop Visit FC" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tnsv_fc ? returnCond?.titan_extra_fields?.tnsv_fc : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tnsv_fc"
                        label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV FC<Tooltip title="Time to the Next Shop Visit FC" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>}                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tnsv_fc?returnCond?.titan_extra_fields?.tnsv_fc:''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => regexConstants.onlyNumeric.test(e.target.value)?this.onFieldChange(e, 'tnsv_fc', e.target.value):e.preventDefault()}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                  <LabelValueCard md={6} label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV Month<Tooltip title="Time to the Next Shop Visit Month" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>} value={returnCond?.titan_extra_fields?.tnsv_month ? returnCond?.titan_extra_fields?.tnsv_month : '--'} /> :
                    <Grid item xs={6}>
                      <TextField
                        id="tnsv_month"
                        label={<span style={{ display: 'flex', alignItems: 'center' }}>TNSV Month<Tooltip title="Time to the Next Shop Visit Month" placement='right' ><InfoIcon style={{ marginLeft: '5px', fontSize: '1rem', color: 'grey' }} /></Tooltip></span>}                        fullWidth
                        margin="normal"
                        value={returnCond?.titan_extra_fields?.tnsv_month}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'tnsv_month', e.target.value)}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                      <LabelValueCard md={6} label='Flight Hours' value={returnCond?.titan_extra_fields?.flight_hours ? returnCond?.titan_extra_fields?.flight_hours : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="flight_hours"
                          label="Flight Hours"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.flight_hours ? returnCond?.titan_extra_fields?.flight_hours : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'flight_hours', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Flight Cycles' value={returnCond?.titan_extra_fields?.flight_cycles ? returnCond?.titan_extra_fields?.flight_cycles : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="flight_cycles"
                          label="Flight Cycles"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.flight_cycles ? returnCond?.titan_extra_fields?.flight_cycles : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ? this.onFieldChange(e, 'flight_cycles', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    }
                  </>:null}
                    {(avationPlcInstance||mtInstance||leshaBankInstance)?<>      
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Months Since Last SV' value={returnCond?.titan_extra_fields?.months_since_last_sv ? returnCond?.titan_extra_fields?.months_since_last_sv : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="months_since_last_sv"
                          label="Months Since Last SV"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.months_since_last_sv ? returnCond?.titan_extra_fields?.months_since_last_sv : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'months_since_last_sv', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Hours Since Last SV' value={returnCond?.titan_extra_fields?.hours_since_last_sv ? returnCond?.titan_extra_fields?.hours_since_last_sv : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="hours_since_last_sv"
                          label="Hours Since Last SV"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.hours_since_last_sv ? returnCond?.titan_extra_fields?.hours_since_last_sv : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'hours_since_last_sv', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Cycles Since Last SV' value={returnCond?.titan_extra_fields?.cycles_since_last_sv ? returnCond?.titan_extra_fields?.cycles_since_last_sv : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="cycles_since_last_sv"
                          label="Cycles Since Last SV"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.cycles_since_last_sv ? returnCond?.titan_extra_fields?.cycles_since_last_sv : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.onlyNumeric.test(e.target.value) ? this.onFieldChange(e, 'cycles_since_last_sv', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    } </>:null}
                    {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance)?<>
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Block Hours' value={returnCond?.titan_extra_fields?.block_hours ? returnCond?.titan_extra_fields?.block_hours : '--'} /> :
                      <Grid item xs={6}>
                        <TextField
                          id="block_hours"
                          label="Block Hours"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.block_hours ? returnCond?.titan_extra_fields?.block_hours : ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'block_hours', e.target.value) : e.preventDefault()}
                        />
                      </Grid>
                    }
                    {returnCond?.asset_conditions_for_contract?.name === "APU" ? <>
                      {mode === 'view' ?
                        <LabelValueCard md={6} label='APU Hours' value={returnCond?.titan_extra_fields?.apu_hours ? returnCond?.titan_extra_fields?.apu_hours : '--'} /> :
                        <Grid item xs={6}>
                          <TextField
                            id="apu_hours"
                            label="APU Hours"
                            fullWidth
                            margin="normal"
                            value={returnCond?.titan_extra_fields?.apu_hours ? returnCond?.titan_extra_fields?.apu_hours : ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'apu_hours', e.target.value) : e.preventDefault()}
                          />
                        </Grid>
                      }
                      {mode === 'view' ?
                        <LabelValueCard md={6} label='APU Cycles' value={returnCond?.titan_extra_fields?.apu_cycle ? returnCond?.titan_extra_fields?.apu_cycle : '--'} /> :
                        <Grid item xs={6}>
                          <TextField
                            id="apu_cycle"
                            label="APU Cycles"
                            fullWidth
                            margin="normal"
                            value={returnCond?.titan_extra_fields?.apu_cycle ? returnCond?.titan_extra_fields?.apu_cycle : ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => this.onFieldChange(e, 'apu_cycle', e.target.value)}
                          />
                        </Grid>
                      }</> : null}
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Reading' value={returnCond?.titan_extra_fields?.reading || '--'} /> :
                      <Grid item xs={6} md={6}>
                        <TextField
                          id="reading"
                          label="Reading"
                          fullWidth
                          margin="normal"
                          value={returnCond?.titan_extra_fields?.reading || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={e => this.onFieldChange(e, 'reading', e.target.value)}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={6} label='Released' value={returnCond?.titan_extra_fields?.released ? returnCond?.titan_extra_fields?.released : '--'} /> :
                      <Grid item xs={6}>
                        {(() => {
                          let options = ['Yes', 'No'];
                          return (
                            <Autocomplete
                              options={options}
                              disableClearable={true}
                              getOptionLabel={option => option}
                              name="released"
                              value={returnCond?.titan_extra_fields?.released}
                              onChange={(e, value) => { this.onFieldChange(e, 'released', value); }}
                              renderInput={params => <TextField style={{ height:'49px' }} {...params} label="Released " placeholder='Select Released' margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                            />
                          )
                        })()}
                      </Grid>
                    }</> : null}
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Remarks" value={ returnCond.remarks? ( <span dangerouslySetInnerHTML={{ __html: returnCond.remarks.replace(/\n/g, '<br />')}}/>): '--'}/>:
                    <Grid item xs={12}>
                      <TextField
                        id="remarks"
                        label="Remarks"
                        fullWidth
                        margin="normal"
                        multiline
                        rows="4"
                        // inputProps={{ maxLength: 1000 }}
                        value={returnCond.remarks}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'remarks', e.target.value)}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label='Flag this Return Condition' value={returnCond.flags ? 'Yes' : 'No'} /> :
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox color="primary" checked={returnCond.flags} onChange={(e) => this.onFieldChange(e, 'flags', e.target.checked)} value="Flag this Return Condition" />
                        }
                        label="Flag this Return Condition"
                      />
                    </Grid>
                  }
                  {mode === 'view'  ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)',fontFamily:"Conv_IBMPlexSans-Regular" }}>Attachment(s) {returnCond?.pooling_language?.length>0 ? `[Count : ${returnCond?.pooling_language?.length}]` : null}</p>
                      {returnCond.pooling_language?.length>0 ? returnCond.pooling_language.map((file, index) => (
                        <Tooltip key={index} title={`${file.name}`} arrow placement="top">
                          <Chip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            variant="outlined"
                            size="small"
                            label={file.name.substring(0, 14) + '...'}
                            clickable
                            color="primary"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.previewDoc(file) }}
                          />
                        </Tooltip>
                      )) : "--"}
                    </div>
                    :
                    <Grid item xs={12} style={{ marginBottom: '20px' }} className='drag-drop'>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)',fontFamily:"Conv_IBMPlexSans-Regular", marginLeft:'2px' }}>Attachment(s)</p>
                      <DropzoneArea
                        filesLimit={(50 - (returnCond?.pooling_language?.length || 0))}
                        acceptedFiles={['.xls', '.csv', '.xlsx', '.docx', '.pdf', '.jpg', '.jpeg', '.png']}
                        showPreviewsInDropzone={false}
                        showPreviews={true}
                        maxFileSize={5000000000000}
                        useChipsForPreview
                        dropzoneText={<p style={{ fontSize: '12px' }}>Drag & Drop Documents OR Click Here</p>}
                        maxWidth="sm"
                        showAlerts={['error', 'info']}
                        onChange={(files) => this.setState({ attatchedDoc: files })}
                        alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' }, style:{marginTop:'30px'} }}
                      >
                      </DropzoneArea>
                      <h6 style={{ marginTop: '5px', fontSize: '11px' }}>
                        <span><b>Note:</b>Only pdf, docx, csv, xls, xlsx, jpg, jpeg and png files are supported (Maximum Upto 50 files.).{titanInstance?<><br/><span style={{background:'yellow',lineHeight:'normal'}}>The file name must include a keywords <b style={{fontWeight:'bolder',fontFamily:'Conv_IBMPlexSans-Bold'}}>'Lessor and Lessee Engine Substitution language', 'Lessor and Lessee eng sub language', 'Engine Pooling Language', 'pooling language', 'Lessee Engine Substitution language', 'lessee engine substitution language', 'Lessor Engine Substitution language', 'lessor engine substitution language', 'lessee eng sub language', 'lessor eng sub language'</b> and it should be a image file for it to appear in the Lease Summary Report.</span></>:''}</span>
                        <br />
                        {id ? <>
                          Files uploaded <b style={{ font: 'menu' }}>({returnCond?.pooling_language?.length || 0})</b>.
                          {updatedFileLimit < 0 ? <span > You have exceeded file limit, Please remove  <b style={{ font: 'menu', color: "red" }}>({Math.abs(updatedFileLimit)})</b> files.</span> : <span> Files remaining <b style={{ font: 'menu' }}>({updatedFileLimit})</b>.</span>}
                        </> : null}
                      </h6> 
                      {returnCond.pooling_language&&returnCond.pooling_language.map((file, index) => (
                        <Tooltip key={index} title={`${file.name}`} arrow placement="top">
                          <Chip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            variant="outlined"
                            size="small"
                            label={file.name.substring(0, 14) + '...'}
                            clickable
                            color="primary"
                            onClick={(e) => {e.preventDefault(); e.stopPropagation();this.previewDoc(file)}}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.handleDelete(file) }}
                          />
                        </Tooltip>
                      ))}
                    </Grid>}
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditReturnFn} color="primary" variant="contained" >Save Changes</Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', returnCond: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
        {
          previewDocs ? (
            <Dialog open={true} fullScreen >
              <DialogTitle>{previewDocs.name}</DialogTitle>
              <DialogContent style={{ height: '' }} >
                {previewDocs.extension === 'csv' ? (
                  <object id="myObject" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/xls_viewer/index.html?file=${encodeURIComponent(previewDocs.url)}`} style={{width: '100%', height: window.innerHeight - 100}}/>
                ) : ['xls', 'xlsx', 'docx'].includes(previewDocs.extension.toLowerCase()) ? (
                  <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocs.url)}`} width='100%' height={window.innerHeight} frameborder='0'/>
                ) : ['jpg', 'jpeg', 'png'].includes(previewDocs.extension.toLowerCase()) ? (
                  <img
                    src={previewDocs?.url}
                    alt="Attachment"
                    style={{ width:'100%', height: 'auto' }}
                  />) : previewDocs.extension === 'pdf' ? (
                  <object type="text/html" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/pdf.js/web/viewer.html?file=${encodeURIComponent(previewDocs.url)}#search=${window.location.search.substr(window.location.search.indexOf('?searchTerm=') + 12)}`} style={{width: '100%', height: window.innerHeight - 100}}>
                    <param name="type" value="text/html" />
                  </object>
                ) : null}
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="primary" onClick={(e) => downloadFile(previewDocs)}> Download </Button>
                <Button variant="contained" color="primary" onClick={(e) => this.setState({ previewDocs: '' })}> Close </Button>
              </DialogActions>
            </Dialog>
          ) : null
        }
        {deleteAttachmentModal ?
          <DeletePopUp
            modal={deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.deleteAttachment()}
          /> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(ReturnCondCRU));
